<template>
  <v-card>
    <v-card-title class="headline white--text primary">
      <span>
        {{ $t('recoveries')}}
      </span>
      <v-spacer/>
      <span class="mr-3">{{ formatMoney(recoveredTotal) }}</span>
      <BaseDialogActions hideRefresh />
    </v-card-title>
    <v-card-text class="mt-6">
      <DataTable
        hideHeader
        :items.sync="payee.recoveryInfo"
        :headers="headers"
        :customCells="customCells"
        :no-data-text="$t('noRecoveries')"
      >
        <template #type="{ item }">
          <span>{{recoveryTypeFromInt(item.type)}}</span>
        </template>
        <template #rate="{ item }">
          <span>{{getRateText(item.rate, item.type)}}</span>
        </template>
        <template #balance="{ item }">
          <span>{{formatMoney(item.balance)}}</span>
        </template>
        <template #recovered="{ item }">
          <span>{{formatMoney(item.recovered)}}</span>
        </template>
        <template #previouslyRecovered="{ item }">
          <span>{{formatMoney(item.previouslyRecoveredAmount)}}</span>
        </template>
        <template #amount="{ item }">
          <span>{{formatMoney(item.amount)}}</span>
        </template>
        <template #body.append>
          <tr class="font-weight-bold">
            <td class="text-left">{{ $t('totals') }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right">{{formatMoney(advanceTotal)}}</td>
            <td class="text-right">{{formatMoney(previouslyRecoveredTotal)}}</td>
            <td class="text-right">{{formatMoney(recoveredTotal)}}</td>
            <td class="text-right">{{formatMoney(balanceTotal)}}</td>
          </tr>
        </template>
      </DataTable>
    </v-card-text>
  </v-card>
</template>

<script>
import { RecoveryType } from '@/utils/Enumerations.js'
import { formatMoney } from '@/utils/NumericMutations'
import { recoveryRateText } from '@/utils/FinancialHelpers.js'
import { recoveryDialogHeaders } from '@/headers/Cycles.js'

export default {
  name: 'SBPRecoveryDialog',

  props: {
    payee: {
      type: Object,
      required: true
    },
    isExportBatch: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  data: () => ({
    dialog: false
  }),

  computed: {
    advanceTotal () {
      return this.payee.recoveryInfo.map(recovery => recovery.amount).reduce((prev, curr) => prev + curr, 0)
    },
    recoveredTotal () {
      return this.payee.recoveryInfo.map(recovery => recovery.recovered).reduce((prev, curr) => prev + curr, 0)
    },
    balanceTotal () {
      return this.payee.recoveryInfo.map(recovery => recovery.balance).reduce((prev, curr) => prev + curr, 0)
    },
    previouslyRecoveredTotal () {
      return this.payee.recoveryInfo.reduce((acc, curr) => acc + curr.previouslyRecoveredAmount, 0)
    },
    headers () {
      return recoveryDialogHeaders(this.isExportBatch)
    },
    customCells () {
      return [
        {
          slotName: 'method',
          value: 'method'
        },
        {
          slotName: 'type',
          value: 'type'
        },
        {
          slotName: 'rate',
          value: 'rate'
        },
        {
          slotName: 'balance',
          value: 'balance'
        },
        {
          slotName: 'recovered',
          value: 'recovered'
        },
        {
          slotName: 'amount',
          value: 'amount'
        },
        {
          slotName: 'previouslyRecovered',
          value: 'previouslyRecovered'
        }
      ]
    }
  },

  methods: {
    recoveryTypeFromInt: (x) => RecoveryType.fromInt(x),
    formatMoney,
    close (refresh) {
      this.dialog = false
    },

    getRateText (rate, type) {
      return recoveryRateText(rate, type)
    }
  }
}
</script>
